import { ReloadOutlined } from "@ant-design/icons";
import { Button, Divider, Form, Input, Typography } from "antd";
import classNames from "classnames";
import { useTranslation } from "react-i18next";

import { PasswordField, PasswordFieldConfirm } from "@/modules/password-field";
import { CardInView } from "@/ui/card-in-view";
import { StepBadge } from "@/ui/step-badge";

import { usePasswordUpdate } from "./password-update.hook";

import "./password-update.style.less";

const { Title } = Typography;
const { Paragraph } = Typography;

const FORM_ID = "updatePasswordForm";

export const PasswordUpdate = () => {
  const { t } = useTranslation();

  const {
    form,
    step1Status,
    step2Status,
    isSending,
    isSent,
    isSubmitting,
    onSendClick,
    onSubmit,
  } = usePasswordUpdate();

  return (
    <CardInView
      title={t("user:updatePassword.title")}
      footerActions={
        <Button
          loading={isSubmitting}
          data-testid="updatePassword"
          type="primary"
          htmlType="submit"
          form={FORM_ID}
          disabled={!isSent}
        >
          {t("global:update")}
        </Button>
      }
    >
      <Form id={FORM_ID} form={form} layout="vertical" onFinish={onSubmit}>
        <Title
          level={3}
          className={classNames("password-update-step-title", {
            [`-${step1Status}`]: step1Status,
          })}
        >
          <StepBadge step={1} status={step1Status} />
          {t("user:updatePassword.resetCode.title")}
        </Title>
        <Paragraph>{t("user:updatePassword.resetCode.info")}</Paragraph>
        <Button
          loading={isSending}
          icon={isSent ? <ReloadOutlined /> : undefined}
          onClick={onSendClick}
        >
          {isSent ? t("global:resend") : t("global:send")}
        </Button>
        <Divider />
        <Title
          level={3}
          className={classNames("password-update-step-title", {
            [`-${step2Status}`]: step2Status,
          })}
        >
          <StepBadge step={2} status={step2Status} />
          {t("user:updatePassword.stepTitle")}
        </Title>
        <Form.Item
          name="confirmationCode"
          label={t("user:form.resetCode.label")}
          rules={[{ required: true }]}
        >
          <Input placeholder={t("user:form.resetCode.label")} />
        </Form.Item>
        <PasswordField
          name="newPassword"
          label={t("user:form.newPassword.label")}
          enforceStrongPassword
        />
        <PasswordFieldConfirm
          name="newPasswordConfirmation"
          label={t("user:form.newPasswordConfirmation.label")}
          confirmField="newPassword"
        />
      </Form>
    </CardInView>
  );
};
